import React, { useEffect, useMemo, useState } from 'react'
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../../components/Component';
import Content from '../../../../../layout/content/Content';
import Head from '../../../../../layout/head/Head';

import { Col, Form, Button, FormGroup } from 'reactstrap';

import { Controller, useForm } from 'react-hook-form';
import { getSingleStore, getStoreItem, updateStore, updateStoreItem } from '../../../../../redux/admin/store/action';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useParams } from 'react-router';
import * as yup from "yup";
import { string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ToastExample from '../../../../../helpers/toast';
import { Image } from 'antd';
import noimage from '../../../../../assets/images/noimage.png'
import { getAllItemCategories } from '../../../../../redux/admin/item/action';
import { ColorRing } from 'react-loader-spinner';

const EditStoreItem = (props) => {

    const getSelectors = (state) => ({
        store_item: state.store.store_item?.item,
        cities: state.cities.cities,
        categories: state.item.item_categories,
    });


    const { store_item, categories } = useSelector(getSelectors);
    const dispatch = useDispatch();
    const { item_id } = useParams();
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(false);

    const [discount, setDiscount] = useState(false);  //discout state defined

    const [image, setImage] = useState([]);  // state defined
    const [popular, setPopular] = useState(store_item?.is_popular ? true : false);  // state defined
    const [veg, setVeg] = useState(store_item?.is_veg ? true : false);  // state defined
    const [recommended, setRecommended] = useState(store_item?.is_recommended ? true : false);  // state defined


    useEffect(() => {
        setLoading(true);
        dispatch(getAllItemCategories());
        const form_data = new FormData();
        form_data.append('id', item_id);
        dispatch(getStoreItem(form_data)).then((response) => {
            setLoading(false);
        })
    }, [])

    //form validation with yup
    const itemSchema = yup.object({
        name: yup.string(),
        description: yup.string(),
        store_id: yup.string(),
        item_category_id: yup.string(),
        price: yup.string(),
        min_quantity: yup.string(),
        commission_rate: yup.string(),
    });

    //form values
    const defaultValues = useMemo(() => ({
        id: store_item?.id || "",
        name: store_item?.name || "",
        description: store_item?.description || "",
        store_id: store_item?.store_id || "",
        item_category_id: store_item?.item_category_id || "",
        price: store_item?.price || "",
        mrp: store_item?.mrp || "",
        min_quantity: store_item?.min_quantity || "",
        max_quantity: store_item?.max_quantity || "",
        commission_rate: store_item?.commission_rate || "",
    }), [store_item]);

    const methods = useForm({
        resolver: yupResolver(itemSchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        setError,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;


    const onFormSubmit = (submitData) => {
        console.log('sssffs')
        const new_data = new FormData();
        new_data.append('id', store_item?.id)
        new_data.append('name', submitData?.name);
        if (image) {
            new_data.append('image', image);
        }
        new_data.append('description', submitData?.description);
        new_data.append('store_id', store_item?.store_id);
        new_data.append('item_category_id', submitData?.item_category_id);
        new_data.append('price', submitData?.price);
        new_data.append('mrp', submitData?.mrp);
        new_data.append('min_quantity', submitData?.min_quantity);
        new_data.append('max_quantity', submitData?.max_quantity);
        new_data.append('commission_rate', submitData?.commission_rate);
        new_data.append('is_popular', popular);
        new_data.append('is_recommended', recommended);
        new_data.append('is_veg', veg);
        dispatch(updateStoreItem(new_data));
    };

    const listCategory = categories?.map((category) => (
        { value: category.id, label: category.name }

    ));

    return (
        <React.Fragment>
            <Head title="Edit Item"></Head>
            {loading ?
                <Content>
                    <div className='d-flex align-items-end justify-content-center'>
                        <ColorRing
                            visible={true}
                            height="120"
                            width="120"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        />
                    </div>
                </Content>
                :
                <Content>
                    <BlockHead size="sm">
                        <BlockBetween>
                            <BlockHeadContent>
                                <BlockTitle tag="h3" page>Edit Item <div className='badge badge-info'>{store_item?.store?.name}</div></BlockTitle>
                            </BlockHeadContent>
                            <BlockHeadContent>
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <ToastExample show={showToast} />
                                </div>
                            </BlockHeadContent>
                        </BlockBetween>
                    </BlockHead>
                    <React.Fragment>
                        <div className="p-2">
                            <div className="mt-4">
                                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Item Name</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="name"
                                                placeholder="Enter Item Name"
                                                ref={register()}
                                            />
                                            {errors.name && <span className="invalid">{errors.name.message}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label" >Image </label>
                                            <input
                                                className="form-control"
                                                type="file"
                                                name="image"
                                                accept="image/png, image/jpeg, image/jpg"
                                                onChange={(e) => {
                                                    setImage(e.target.files[0])
                                                }}
                                            />
                                            {errors.image && <span className="invalid">{errors.image.message}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <label className="form-label">Current Image </label>
                                            <div className="" id={store_item.id}>
                                                {store_item?.image ?
                                                    <Image style={{ objectFit: 'cover', height: '20vh' }} src={store_item?.image} />
                                                    :
                                                    <>
                                                        <img src={noimage} alt="item category" style={{ height: '7vh', width: '7vh' }} />
                                                        <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                    </>
                                                }
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <label className="form-label">Description</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="description"
                                                placeholder="Enter Description"
                                                ref={register()}
                                            />
                                            {errors.description && <span className="invalid">{errors.description.message}</span>}
                                        </FormGroup>
                                    </Col>

                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">{discount ? 'Selling Price' : 'Price'}</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="price"
                                                min={0}
                                                placeholder={discount ? "Enter Selling Price" : "Enter Price"}
                                                ref={register()}
                                            />
                                            {errors.price && <span className="invalid">{errors.price.message}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={discount ? '4' : '0'}>
                                        <div style={discount ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Market Price</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="mrp"
                                                    min={0}
                                                    placeholder="Enter Market Price"
                                                    ref={register()}
                                                />
                                            </FormGroup>
                                        </div>
                                    </Col>
                                    <div className='mt-4 ml-3' onClick={() => setDiscount(!discount)}>
                                        <div className='pt-1' >
                                            <Button className="btn-icon py-1 px-2 btn-dim" color="primary" size="rg" style={{ pointerEvents: 'none' }}>
                                                {discount ? <Icon name="minus-sm" /> : <><Icon name="plus-sm" />Add Discount</>}
                                            </Button>
                                        </div>
                                    </div>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Item Category</label>
                                            <div className="form-control-wrap">
                                                <Controller
                                                    name="item_category_id"
                                                    control={control}
                                                    render={({ onChange, value, ref }) => (
                                                        <RSelect
                                                            options={listCategory}
                                                            onChange={(val) => onChange(val.value)}
                                                            defaultValue={listCategory?.find((cat) => cat.value === value)}
                                                        />
                                                    )}
                                                />
                                                {errors.item_category_id && (
                                                    <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Category</span>
                                                )}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Quantity(minimum)</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="min_quantity"
                                                min={0}
                                                placeholder="Enter Minimum Quantity"
                                                ref={register()}
                                            />
                                            {errors.min_quantity && <span className="invalid">{errors.min_quantity.message}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Quantity(maximum)</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="max_quantity"
                                                min={0}
                                                placeholder="Enter Maximum Quantity"
                                                ref={register()}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Commission Rate</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                name="commission_rate"
                                                min={0}
                                                placeholder="Enter Commission Rate"
                                                ref={register()}
                                            />
                                            {errors.commission_rate && <span className="invalid">{errors.commission_rate.message}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup >
                                            <div className="custom-control-sm custom-switch">
                                                <input type="radio" className="custom-control-input" id="popular" checked={popular} onClick={() => setPopular(!popular)} />
                                                <label className="custom-control-label user-select-none" htmlFor="popular">Is Popular </label>
                                            </div>
                                        </FormGroup>

                                        <FormGroup >
                                            <div className="custom-control-sm custom-switch">
                                                <input type="radio" className="custom-control-input" id="recommend" checked={recommended} onClick={() => setRecommended(!recommended)} />
                                                <label className="custom-control-label user-select-none" htmlFor="recommend">Is Recommended </label>
                                            </div>
                                        </FormGroup>

                                        <FormGroup >
                                            <div className="custom-control-sm custom-switch">
                                                <input type="radio" className="custom-control-input" id="veg" checked={veg} onClick={() => setVeg(!veg)} />
                                                <label className="custom-control-label user-select-none" htmlFor="veg">Is Veg </label>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <div className="d-flex justify-content-end">
                                            <Button type="submit" color="primary" size="lg" className="btn-mb">
                                                Update Item
                                            </Button>
                                        </div>
                                    </Col>
                                </Form>
                            </div>
                        </div>
                    </React.Fragment>
                </Content>
            }
        </React.Fragment>
    )
}

export default EditStoreItem
